export const getFileTypeFromUrl = (url: string): "pdf" | "powerpoint" => {
    const extension = url.toLowerCase().split(".").pop();
    return extension === "pdf" ? "pdf" : "powerpoint";
};
